/**
 * Skins. Every color lives in index.css — :root is Forest, each other skin is
 * a [data-theme='…'] block there. This module only flips the attribute on
 * <html>, remembers the choice, and keeps the browser chrome color in step.
 * The inline script in index.html applies the saved skin before first paint;
 * this module owns it from then on.
 */
export interface Skin {
  id: string;
  name: string;
}

export const SKINS: Skin[] = [
  { id: 'forest', name: 'Forest' },
  { id: 'ocean', name: 'Ocean' },
  { id: 'retro70', name: 'Rétro 70' },
  { id: 'sedona', name: 'Sedona' },
];

const KEY = 'momento-theme';
const DEFAULT_SKIN = 'forest';

export function getTheme(): string {
  try {
    const t = localStorage.getItem(KEY);
    return SKINS.some((s) => s.id === t) ? (t as string) : DEFAULT_SKIN;
  } catch {
    return DEFAULT_SKIN;
  }
}

export function applyTheme(id: string): void {
  if (!SKINS.some((s) => s.id === id)) id = DEFAULT_SKIN;
  const root = document.documentElement;
  if (id === DEFAULT_SKIN) {
    delete root.dataset.theme;
  } else {
    root.dataset.theme = id;
  }
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* private mode — the skin still applies for this session */
  }
  // Status bar / PWA chrome follows the skin's paper. Read the value the CSS
  // actually resolved so there is no second copy of any hex here.
  const paper = getComputedStyle(root).getPropertyValue('--color-background').trim();
  if (paper) {
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', paper);
  }
}
